import { EventRsvpOption, PublicFeedEvent } from "./event";

export enum UserConnectionStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum PublicUserConnectionStatus {
  PendingReceived = 'pendingReceived',
  PendingSent = 'pendingSent',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export type ConnectionRsvpStatus = EventRsvpOption | 'interested' | 'entertaining' | 'promoting';

export interface PublicUserConnection {
  _id: string;
  connectionUserId: string;
  connectionName: string;
  connectionAvatar?: string;
  goingEventCount: number;
  maybeEventCount: number;
  status: PublicUserConnectionStatus;
  createdAt: string;
  updatedAt: string;
}

export interface PublicSuggestedConnection {
  connectionUserId: string;
  connectionName: string;
  connectionAvatar?: string;
  mutualConnectionCount: number;
  mutualConnectionUserIds: string[];
  goingEventCount: number;
  maybeEventCount: number;
  taggedCount: number;
}

export interface ScheduleDateDetailsEvent {
  _id: string;
  startDate: string;
  startTime?: string;
  showName: string;
  venue: string;
}

export interface PublicUserConnectionComparison extends Partial<PublicUserConnection> {
  isCalendarPublic: boolean;
  connectionUserId: string;
  connectionName: string;
  connectionAvatar?: string;
  entertainingEventCount: number;
  promotingEventCount: number;
  goingEventCount: number;
  maybeEventCount: number;
  interestedEventCount: number;
  entertainingEvents: (PublicFeedEvent | ScheduleDateDetailsEvent)[];
  promotingEvents: (PublicFeedEvent | ScheduleDateDetailsEvent)[];
  goingEvents: PublicFeedEvent[];
  maybeEvents: PublicFeedEvent[];
  interestedEvents: PublicFeedEvent[];
  connectionRsvps: Record<string, ConnectionRsvpStatus>;
}
